var _rect, _rect2, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#4DA85C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_735_244",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_735_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9896 6.8335L23.5312 11.3335C23.7812 11.4863 23.9757 11.6946 24.1146 11.9585C24.2535 12.2224 24.3229 12.5002 24.3229 12.7918V21.8335C24.3229 22.2918 24.1597 22.6842 23.8333 23.0106C23.5069 23.337 23.1146 23.5002 22.6562 23.5002H9.32292C8.86458 23.5002 8.47222 23.337 8.14583 23.0106C7.81944 22.6842 7.65625 22.2918 7.65625 21.8335V12.7918C7.65625 12.5002 7.72569 12.2224 7.86458 11.9585C8.00347 11.6946 8.19792 11.4863 8.44792 11.3335L15.9896 6.8335ZM15.9896 16.5418L22.4896 12.6668L15.9896 8.79183L9.48958 12.6668L15.9896 16.5418ZM15.9896 18.5002L9.32292 14.5002V21.8335H22.6562V14.5002L15.9896 18.5002Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.2f98ff4c.svg";
export { ForwardRef as ReactComponent };